import { authorizations } from "./authorizations";
import { fees } from "./fees";
import { sales } from "./sales";
import { refunds } from "./refunds";
import { net_settled_cash } from "./netSettledCash";
import { average_ticket } from "./averageTicket";
import { chargebacks } from "./chargebacks";

const subtypes = {
    authorizations,
    fees,
    sales,
    refunds,
    net_settled_cash,
    average_ticket,
    chargebacks
};

export const getBySubtype = function(subtype, options) {
    const widgetConfig = subtypes[subtype];
    
    if (widgetConfig) {
        return typeof widgetConfig === "function" && options ? widgetConfig(options) : widgetConfig;
    }
    
    return {};
};
